import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IRequiredValidation } from '@models/actions/IRequiredValidation';
import { IDocumentsBatchEditingExecutorProps } from './IDocumentsBatchEditingExecutorProps';
import { DocumentsBatchEditingExecutorModal } from './DocumentsBatchEditingExecutorModal';

export const DocumentsBatchEditingExecutor = createDocModalExecutor<IDocumentsBatchEditingExecutorProps>({
    modal: DocumentsBatchEditingExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        attachFiles: action.options?.attachFiles == true,
        attachRequired: action.options?.attachRequired == true,
        attachRequiredValidation: action.options?.attachRequiredValidation as IRequiredValidation[],
        addMailReminders: action.options?.addMailReminders == true,
        virtualFields: action.options?.virtualFields as string[],
        showCurrentValues: action.options?.showCurrentValues ?? true,
        onlyEditValues: action.options?.onlyEditValues ?? false,
        showSuccessText: action.options?.showSuccessText ?? false,
        successText: action.options?.successText,
        postActions: action.options?.postActions as any[],
        completeHandler,
    }),
});
